"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiService_1 = __importDefault(require("./ApiService"));
const _defaultConfig_1 = require("../_defaultConfig");
const common_1 = require("@affinidi/common");
let RevocationService = class RevocationService {
    constructor(options = {}) {
        this._revocationUrl = options.revocationUrl || _defaultConfig_1.STAGING_REVOCATION_URL;
        const { registryUrl, issuerUrl, verifierUrl } = options;
        this._api = new ApiService_1.default(registryUrl, issuerUrl, verifierUrl, options);
    }
    buildRevocationListStatus({ credentialId, subjectDid }, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this._revocationUrl}/api/v1/revocation/build-revocation-list-2020-status`;
            const headers = {
                authorization: accessToken,
            };
            const { body: { credentialStatus, revocationListCredential }, } = yield this._api.execute(null, {
                url,
                headers,
                params: { credentialId, subjectDid },
                method: 'POST',
            });
            const isPublisRequired = !!revocationListCredential;
            return { credentialStatus, revocationListCredential, isPublisRequired };
        });
    }
    publishRevocationListCredential(revocationListCredential, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this._revocationUrl}/api/v1/revocation/publish-revocation-list-credential`;
            const headers = {
                authorization: accessToken,
            };
            yield this._api.execute(null, {
                url,
                headers,
                params: revocationListCredential,
                method: 'POST',
            });
        });
    }
    revokeCredential(credentialId, revocationReason, accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this._revocationUrl}/api/v1/revocation/revoke-credential`;
            const headers = {
                authorization: accessToken,
            };
            const { body: { revocationListCredential }, } = yield this._api.execute(null, {
                url,
                headers,
                params: { id: credentialId, revocationReason },
                method: 'POST',
            });
            return { revocationListCredential };
        });
    }
};
RevocationService = __decorate([
    common_1.profile()
], RevocationService);
exports.default = RevocationService;
//# sourceMappingURL=RevocationService.js.map